/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import AcChargerPanelRemoteCommandsComponent from './AcChargerPanelRemoteCommandsComponent'
import { getAcChargerReducer } from '../../../rmsReduxStore/acReduxExports'
import { useAppSelector } from '../../../../rmsReduxStore/rmsReduxHooks'


interface ChargerPanelProps { contentHeight: number }

const AcChargerPanelRemoteCommandsDashboard = React.memo(
  
  function ChargerPanelRemoteCommandsDashboard({ contentHeight }: ChargerPanelProps) {
    const {allowedCommandsForRoleReferenceData} = useAppSelector(getAcChargerReducer)

   const remoteCommandsNavList = [
      { buttonText: 'Soft Reset', buttonIconClassName: 'panel_soft_reset_icon', buttonId: 'soft_reset' },
      { buttonText: 'Hard Reset', buttonIconClassName: 'panel_hard_reset_icon', buttonId: 'hard_reset'  },
      { buttonText: 'FTP software upgrade', buttonIconClassName: 'panel_ftp_software_connector_icon', buttonId: 'ftp_software_upgrade'},
      { buttonText: 'FTP Customer Logo update', buttonIconClassName: 'panel_ftp_customer_logo_update_icon', buttonId: 'ftp_customer_logo_update' },
      { buttonText: 'Calibrate Voltage', buttonIconClassName: 'panel_calibrate_voltage_icon', buttonId: 'calibrate_voltage' },
      { buttonText: 'Calibrate Display', buttonIconClassName: 'panel_calibrate_display_icon', buttonId: 'calibrate_display' },
      { buttonText: 'FTP Certificate Upgrade', buttonIconClassName: 'panel_ftp_certificate_upgrade_icon', buttonId: 'ftp_certificate_upgrade'},
      { buttonText: 'FTP Screen Saver Images Upgrade', buttonIconClassName: 'panel_ftp_screen_saver_images_upgrade_icon', buttonId: 'ftp_screen_saver_images_upgrade'},
      { buttonText: 'Clear Screen Saver Images', buttonIconClassName: 'panel_clear_txn_data_icon', buttonId: 'clear_screen_saver_images'},
      { buttonText: 'Reset Counter', buttonIconClassName: 'panel_clear_txn_data_icon', buttonId: 'reset_counter'},
      { buttonText: 'FTP Config File Update', buttonIconClassName: 'panel_ftp_certificate_upgrade_icon', buttonId: 'ftp_config_file_update'},
      { buttonText: 'PLC Software Upgrade', buttonIconClassName: 'panel_ftp_software_connector_icon', buttonId: 'plc_software_upgrade'},
    ]
    const allowedCommands = remoteCommandsNavList?.filter((command) => allowedCommandsForRoleReferenceData?.includes(command?.buttonId))
    return (<AcChargerPanelRemoteCommandsComponent contentHeight={contentHeight} commands={allowedCommands}/>)
  }
)

export default AcChargerPanelRemoteCommandsDashboard
